var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.801 21.7317H3.17465C1.42129 21.7317 0 20.2867 0 18.5041V3.22757C0 1.44498 1.42129 0 3.17465 0H25.801C27.5543 0 28.9756 1.44498 28.9756 3.22757V18.5041C28.9756 20.2867 27.5543 21.7317 25.801 21.7317ZM17.4842 9.42001L13.0091 14.6508C12.7173 14.9919 12.1993 15.0011 11.8958 14.6706L9.48889 12.0488C9.19265 11.7261 8.68944 11.7261 8.3932 12.0488L4.26216 16.5487C3.81502 17.0356 4.15482 17.8303 4.81001 17.8303H24.1654C24.8083 17.8303 25.1527 17.0615 24.7309 16.5684L18.6151 9.41985C18.3164 9.07062 17.7831 9.07062 17.4844 9.41985L17.4842 9.42001ZM11.4182 4.80132C10.2348 4.80132 9.27559 5.77662 9.27559 6.97962C9.27559 8.18262 10.2349 9.15793 11.4182 9.15793C12.6015 9.15793 13.5608 8.18262 13.5608 6.97962C13.5608 5.77662 12.6015 4.80132 11.4182 4.80132Z",
    fill: "url(#paint0_linear_2391_22947)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2391_22947",
    x1: 1.78705e-8,
    y1: 11.5903,
    x2: 28.9756,
    y2: 11.5903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenNoImage);
export default __webpack_public_path__ + "static/media/token_no_image.2ca6c387da8e0e4a53832a5c3577302d.svg";
export { ForwardRef as ReactComponent };